import { AmlFlowEnum } from '@/api';
import { flowDisplayMap } from '@/config';
import { capitalize } from 'lodash';

export default function (flow: string) {
  const displayFlow = flowDisplayMap[flow as AmlFlowEnum] || flow;
  return `${displayFlow.charAt(0).toUpperCase()}${displayFlow.slice(1)}`;
}
